import React from 'react'
import { Box, Chip } from '@mui/material'

export default function CustomerCell({ customerName, customerID }) {
    return (
        <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
            <span style={{ fontWeight: 500 }}>{customerName}</span>
            <Chip label={customerID} size="small" color="primary" variant="outlined" />
        </Box>
    )
}
